{
  "appName": "10-10d Extended",
  "entryFile": "./app-entry.jsx",
  "entryName": "10-10d-extended",
  "rootUrl": "/forms/10-10d/apply-champva-benefits",
  "productId": "dee6902f-39e1-44ee-9d3d-4625cb32bb1b",
  "datadog": {
    "applicationId": "cca24a05-9ea0-49ea-aaa9-0d1e04a17ba0",
    "clientToken": "puba5e0866f8008f60a6bc8b09ae555dd92",
    "service": "10-10d",
    "toggleName": "form1010dBrowserMonitoringEnabled",
    "sessionReplaySampleRate": 100
  }
}
